import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  standalone: true,
  selector: 'idp-guided-navigation-error-mach-core',
  templateUrl: './guided-navigation-error-mach-core.component.html'
})
export class GuidedNavigationErrorMachCoreComponent implements OnInit {
  toContinueText = '';
  errorMsg = '';
  @Input() set errorMessage(errMsg: string) {
    if (errMsg && errMsg.includes(',')) {
      const parts = errMsg.split(',');
      this.toContinueText = `${parts[0]},`;
      this.errorMsg = parts[1];
    } else {
      this.toContinueText = '';
      this.errorMsg = errMsg || '';
    }
  }

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.elementRef?.nativeElement?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    this.elementRef?.nativeElement?.focus();
  }

  protected handleErrorMessageClick() {
    const element = document.querySelector('.book-widget-field-error');
    if (!element) return;
    const focusableElement = this.findFocusableElement(element);
    if (focusableElement) {
      (focusableElement as HTMLElement).focus();
      (focusableElement as HTMLElement).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    }
  }

  private findFocusableElement(element: Element) {
    const owRoutePickerElement = element.querySelector(
      "button[data-has-error='true']"
    );
    const mcRoutePickerElementList = element.querySelectorAll(
      "button[aria-invalid='true']"
    );

    const mcRoutePickerElement = mcRoutePickerElementList[0];
    const datePickerTrigger = element.querySelector(
      '.aura-date-picker__trigger'
    );

    return (
      owRoutePickerElement ||
      mcRoutePickerElement ||
      datePickerTrigger ||
      element
    );
  }
}
